import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { IApiResponse } from '../modelo/PageProps';
import { Observable } from 'rxjs';
import { ProjetoResposta } from '../modelo/Projeto';

@Injectable({
  providedIn: 'root'
})
export class ExportacoesService {
    apiUrl: string = `${environment.backendUrl}/exportacao`;

  constructor(private http: HttpClient) { }

    httpOptions = {
        headers: {
            'Content-Type': 'application/json',
        }
    }

    getExportacoes ( projetos: ProjetoResposta[]): Observable<Blob>{
      let searchParams = new HttpParams();

      return this.http.post<any>(`${this.apiUrl}`, projetos,
      { responseType: 'blob' as 'json' });
    }

}
